import _ from 'lodash';
import request from 'superagent';
import * as types from '../actionTypes/irSearchActionTypes';
import * as docketActionTypes from '../actionTypes/docketsActionTypes';
import { requestCaseData } from './irSearchActions';
import { getDockets, getDocketsFromResp, onFailure } from './docketActions';

export function updateHasMoreRecentFilingDate(response) {
  const { docket_headers = {} } = _.find(response.body.items, 'docket_headers') || {};
  const { meta = {} } = _.find(docket_headers, 'meta') || {};
  const hasMoreRecentFilingsDate =
    parseInt(meta.latest_docket_number, 10) < parseInt(meta.latest_history_number, 10)
      ? meta.latest_known_date_filed
      : null;

  return {
    type: docketActionTypes.UPDATE_DOCKET_HEADER,
    docketHeader: { hasMoreRecentFilingsDate },
  };
}

export const loadFavoriteEmails = () =>
  function(dispatch, getState) {
    const state = getState();

    return request
      .get('/ir-documentselect/load_favourite_emails')
      .set('Accept', 'application/json')
      .then(
        response => {
          if (!_.isEmpty(response.body.error) || response.body.success < 1) {
            return dispatch(onFailure({ response }));
          }
          const { data, lastUpdated, receipt } = state.toJS().irSearch;
          data.push(['favoriteEmail', response.body.email]);

          dispatch({
            type: types.RECEIVE_CASE_DATA,
            data_type: 'dockets',
            data,
            lastUpdated,
            receipt,
          });

          dispatch({
            type: docketActionTypes.DOCKETS_FAVORITE_EMAIL,
            favoriteEmail: { email: response.body.email, status: 'done' },
          });
        },
        responseError => dispatch(onFailure(responseError))
      );
  };

export const getDocketDetails = params =>
  function(dispatch, getState) {
    const { case_uuid, seqNum } = params;

    requestCaseData({}, dispatch);

    dispatch({
      type: docketActionTypes.UPDATE_DOCKET_DETAILS,
      selectedDocket: {
        seqNum,
        status: 'loading',
      },
    });

    const state = getState();

    return request
      .get(`/ir-documentselect-json/${case_uuid}/${seqNum}`)
      .set('Accept', 'application/json')
      .then(
        response => {
          if (response.body && !_.isEmpty(response.body.error)) {
            return dispatch(onFailure({ response }));
          }
          let { data } = state.toJS().irSearch;

          // add the property to color the docket number correctly
          const keys = data.map(p => p[0]);
          if (_.includes(keys, 'docketDetails')) {
            data = data.map(datum => {
              if (datum[0] === 'docketDetails') {
                return [
                  'docketDetails',
                  {
                    details: response.body || [],
                    seqNum,
                  },
                ];
              }
              return datum;
            });
          } else {
            data.push([
              'docketDetails',
              {
                details: response.body || [],
                seqNum,
              },
            ]);
          }

          dispatch({
            type: docketActionTypes.UPDATE_DOCKET_DETAILS,
            selectedDocket: {
              seqNum: params.seqNum,
              status: 'done',
            },
          });

          dispatch({
            type: types.RECEIVE_CASE_DATA,
            data_type: 'dockets',
            data,
            lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
            receipt: _.get(response.body, 'items.receipts[0].text'),
          });
        },
        responseError => {
          dispatch({
            type: docketActionTypes.UPDATE_DOCKET_DETAILS,
            seqNum: null,
          });
          dispatch(onFailure(responseError));
        }
      );
  };

export const getItems = (itemParams, sort_direction, selectedPageNum, receipts = null) =>
  function(dispatch, getState) {
    requestCaseData({}, dispatch);

    const itemQs = {
      date_from: '_',
      date_to: '_',
      doc_range: '_',
      keyword: '_',
      page: 0,
      page_index: 1,
      sort_direction,
      sort_field: 'date_filed',
      ...itemParams,
    };

    if (itemQs.date_from.includes('/')) {
      const from = itemQs.date_from.split('/');
      itemQs.date_from = `${from[2]}-${from[0]}-${from[1]}`;
    }

    if (itemQs.date_to.includes('/')) {
      const to = itemQs.date_to.split('/');
      itemQs.date_to = `${to[2]}-${to[0]}-${to[1]}`;
    }

    const state = getState();

    return request
      .post('/dockets/search')
      .query(itemQs)
      .set('Accept', 'application/json')
      .then(
        response => {
          if (!_.isEmpty(response.body.error)) {
            return dispatch(onFailure({ response }));
            // return dispatch(receiveError(null, { messages: [response.body.error.errorMessage] }));
          }

          const dockets = getDocketsFromResp(response, sort_direction, selectedPageNum);
          const data = Object.keys(dockets).reduce((accum, next) => {
            accum.push([next, dockets[next]]);
            return accum;
          }, []);

          const ds = state.toJS().irSearch.data.reduce((accum, next) => {
            // eslint-disable-next-line
          accum[next[0]] = next[1];
            return accum;
          }, {});

          data.push(['headers', ds.headers || []]);

          return dispatch({
            type: types.RECEIVE_CASE_DATA,
            data_type: 'dockets',
            data,
            lastUpdated: _.get(receipts, '[0].meta.timestamp'),
            receipt: _.get(receipts, '[0].text'),
          });
        },
        responseError => dispatch(onFailure(responseError))
      );
  };

export const deleteAndRepurchase = params => dispatch => {
  const { case_uuid, redactSeqNum, doc_range } = params;
  const repurchaseParams = {
    case_uuid,
    sequence_number: redactSeqNum,
    confirm: 'yes',
  };

  return request
    .post('/dockets/delete-and-repurchase-docket-entry')
    .type('form')
    .send(repurchaseParams)
    .then(
      response => {
        if (!_.isEmpty(response.body.error)) {
          return dispatch(onFailure({ response }));
          // return dispatch(receiveError(null, { messages: [response.body.error.errorMessage] }));
        }

        const getDocketsParams = {
          ...params,
          docket_number_range: doc_range,
        };

        const receipt = _.get(response.body, 'items.receipts[0].text', []);

        dispatch({
          type: docketActionTypes.UPDATE_DOCKETS,
          receipt,
        });

        return dispatch(getDockets(getDocketsParams));
      },
      responseError => dispatch(onFailure(responseError))
    );
};



// WEBPACK FOOTER //
// ./src/redux/actions/drupalDocketActions.js